<a href="${iaaHref}" class="${iaaClass} ${ isDisabled ? 'disabled' : '' }" click.trigger="loading = !loading">
  <span if.bind="!loading">${iaaText}</span>
  <span if.bind="loading">
    <i class="fas fa-spinner fa-w-16 fa-spin fa-lg"></i>
    <!-- <i class="fas fa-spinner fa-w-16 fa-spin fa-lg"></i>&nbsp;&nbsp;${iaaText} -->
  </span>
</a>